import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';

import LayoutComposer from '../LayoutComposer';

import css from './LayoutSingleColumn.module.css';
import NamedLink from '../../NamedLink/NamedLink';

// Commonly used layout
const LayoutSingleColumn = props => {
  const {
    className,
    rootClassName,
    mainColumnClassName,
    children,
    topbar: topbarContent,
    footer: footerContent,
    isHeaderSticky,
    isAuthPage,
    ...rest
  } = props;

  const classes = classNames(
    rootClassName || isAuthPage ? css.authRoot : css.root,
    className,
    isHeaderSticky ? css.sticky : null
  );
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <LayoutComposer areas={layoutAreas} className={classes} {...rest}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              {topbarContent}
            </Topbar>
            <Main as="main" className={classNames(css.main, mainColumnClassName)}>
              {children}
            </Main>
            {/* <div className={css.bottomNavbar}>
              <NamedLink name="LandingPage" className={css.homeIcon}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15 17C14.2005 17.6224 13.1502 18 12 18C10.8498 18 9.79952 17.6224 9 17"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                  <path
                    d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.3831 2 14.5817 2.86667 16.979 4.6L18.4189 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5537 22 13.1388 22H10.8612C7.44633 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                    strokeLinejoin="round"
                  />
                </svg>
                Home
              </NamedLink>
              <NamedLink name="FavouritesPage" className={css.homeIcon}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.4626 3.99415C16.7809 2.34923 14.4404 3.01211 13.0344 4.06801C12.4578 4.50096 12.1696 4.71743 12 4.71743C11.8304 4.71743 11.5422 4.50096 10.9656 4.06801C9.55962 3.01211 7.21909 2.34923 4.53744 3.99415C1.01807 6.15294 0.221721 13.2749 8.33953 19.2834C9.88572 20.4278 10.6588 21 12 21C13.3412 21 14.1143 20.4278 15.6605 19.2834C23.7783 13.2749 22.9819 6.15294 19.4626 3.99415Z"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                Favorites
              </NamedLink>
              <NamedLink name="InboxPage" className={css.homeIcon} params={{ tab: 'sales' }}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.06164 15.1933L3.42688 13.1219C3.85856 10.6736 4.0744 9.44952 4.92914 8.72476C5.78389 8 7.01171 8 9.46734 8H14.5327C16.9883 8 18.2161 8 19.0709 8.72476C19.9256 9.44952 20.1414 10.6736 20.5731 13.1219L20.9384 15.1933C21.5357 18.5811 21.8344 20.275 20.9147 21.3875C19.995 22.5 18.2959 22.5 14.8979 22.5H9.1021C5.70406 22.5 4.00504 22.5 3.08533 21.3875C2.16562 20.275 2.4643 18.5811 3.06164 15.1933Z"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M7.5 8L7.66782 5.98618C7.85558 3.73306 9.73907 2 12 2C14.2609 2 16.1444 3.73306 16.3322 5.98618L16.5 8"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M15 11C14.87 12.4131 13.5657 13.5 12 13.5C10.4343 13.5 9.13002 12.4131 9 11"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
                My Trips
              </NamedLink>
              <NamedLink name="DashboardPage" className={css.homeIcon}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="2"
                    y="2"
                    width="8"
                    height="10"
                    rx="2"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                  <rect
                    x="2"
                    y="16"
                    width="8"
                    height="6"
                    rx="2"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                  <rect
                    x="14"
                    y="12"
                    width="8"
                    height="10"
                    rx="2"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                  <rect
                    x="14"
                    y="2"
                    width="8"
                    height="6"
                    rx="2"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                </svg>
                Dashboard
              </NamedLink>
              <NamedLink name="ContactDetailsPage" className={css.homeIcon}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.57757 15.4816C5.1628 16.324 1.45336 18.0441 3.71266 20.1966C4.81631 21.248 6.04549 22 7.59087 22H16.4091C17.9545 22 19.1837 21.248 20.2873 20.1966C22.5466 18.0441 18.8372 16.324 17.4224 15.4816C14.1048 13.5061 9.89519 13.5061 6.57757 15.4816Z"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M16.5 6.5C16.5 8.98528 14.4853 11 12 11C9.51472 11 7.5 8.98528 7.5 6.5C7.5 4.01472 9.51472 2 12 2C14.4853 2 16.5 4.01472 16.5 6.5Z"
                    stroke="#2A353D"
                    strokeWidth="1.5"
                  />
                </svg>
                Account
              </NamedLink>
            </div> */}
            <Footer>{footerContent}</Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

LayoutSingleColumn.displayName = 'LayoutSingleColumn';

LayoutSingleColumn.defaultProps = {
  className: null,
  rootClassName: null,
  footer: null,
};

LayoutSingleColumn.propTypes = {
  className: string,
  rootClassName: string,
  children: node.isRequired,
  topbar: node.isRequired,
  footer: node,
};

export default LayoutSingleColumn;
